import styled from 'styled-components/macro';

export const StyledSvg = styled.svg`
  fill: ${({ color }) => color};
  opacity: ${({ opacity }) => opacity}
`;
